import { Person20Regular } from '@/components/Icon'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import PlanUsageCardShell from './PlanUsageCardShell'
import { PlanUsageTokenTotals } from './PlanUsageTokenTotals'

/**
 * Tokens consumed over the reporting window.
 *
 * Deliberately shows no allowance denominator: nothing in the product defines
 * a token cap, and a fabricated "of 10M" reads as a real limit.
 *
 * @param {{ totals?: object, configured?: boolean, isLoading?: boolean }} props
 */
export default function PlanUsageTokenAllowanceCard({ totals, configured, isLoading }) {
  return (
    <PlanUsageCardShell
      sectionAriaLabel="Token usage"
      title="Token usage"
      titleIcon={<Person20Regular />}
      intro={getSettingsSectionIntro('plan-tokens')}
    >
      <PlanUsageTokenTotals totals={totals} configured={configured} isLoading={isLoading} />
    </PlanUsageCardShell>
  )
}
